import { useEffect, useState } from 'react';
import Joyride, { ACTIONS, EVENTS, STATUS } from 'react-joyride';
import Cookies from 'universal-cookie';
const cookies = new Cookies();

declare interface Props {
  id: string;
  tabIndex?: number | undefined;
  onTabChange?: (tabIndex: number) => void;
  steps?: any[];
}

const ShowTour: React.FC<React.PropsWithChildren<Props>> = ({ id, tabIndex = undefined, onTabChange, steps }) => {
  const [stepIndex, setStepIndex] = useState<number>(0);
  //   const [steps, setSteps] = useState<any>([]);
  const [joyRideRun, setJoyRideRun] = useState<boolean>(false);

  useEffect(() => {
    if (!cookies.get(id + '_VP_ShowViewed')) {
      setJoyRideRun(true);
    }
  }, [id]);

  const handleJoyrideCallback = ({ action, index, type, status }) => {
    if (status == STATUS.RUNNING) {
      cookies.set(id + '_VP_ShowViewed', true, {
        expires: new Date(2100, 1),
        // domain: '.bfgsupply.com',
      });
    }

    if (EVENTS.STEP_AFTER === type) {
      setStepIndex(index + (action === ACTIONS.PREV ? -1 : 1));
      // IF WE HAVE TABS
      if (tabIndex !== undefined) {
        if (index === 1) {
          setJoyRideRun(false);
          onTabChange(1);
          setTimeout(() => {
            setStepIndex(2);
            setJoyRideRun(true);
          }, 1000);
        }
        // THIS TAB DOESN'T WORK FOR SOME REASON
        // if (index === 2) {
        //   setJoyRideRun(false);
        //   onTabChange(2);
        //   setTimeout(() => {
        //     setStepIndex(3);
        //     setJoyRideRun(true);
        //   }, 1000);
        // }
      }
    }
    if (EVENTS.TOUR_END === type) {
      setJoyRideRun(false);
    }
  };

  return (
    <>
      <Joyride
        steps={steps}
        run={joyRideRun}
        callback={handleJoyrideCallback}
        continuous
        showSkipButton
        stepIndex={stepIndex}
        scrollOffset={80}
        styles={{
          options: {
            zIndex: 1000,
          },
        }}
      />
    </>
  );
};

export default ShowTour;
